import React from 'react';
import { NoFormStyle } from '../form/context';
import { NoCompactStyle } from '../space/Compact';
const getInputAddon = (addon) => addon ? (React.createElement(NoCompactStyle, null,
    React.createElement(NoFormStyle, { override: true, status: true }, addon))) : null;
export default getInputAddon;
